import { useUnit } from 'effector-react'
import type { JSX } from 'react'
import { signInByTrueIdFeatureModel } from '~/features/subscriber/sign-in'
import { AuthLayout, SignInTrueIdForm } from '~/widgets/auth'
import { SignInForm } from '~/widgets/auth/SignInForm'
import { AppTitle } from '~/shared/ui/components/AppTitle'

export function Title(): JSX.Element {
  return <AppTitle t='sign_in' />
}

SignInPage.displayName = 'SignInPage'
export function SignInPage(): JSX.Element {
  const trueIdConfig = useUnit(signInByTrueIdFeatureModel.$trueIdConfig)

  return (
    <AuthLayout>
      {trueIdConfig ? <SignInTrueIdForm /> : <SignInForm />}
    </AuthLayout>
  )
}
